module.exports = __webpack_public_path__ + "site/img/14.ba915551.jpg";